import React from "react";
import { Form, Input, Row, Col } from "antd";

const DocumentDetails = (props) => {
  const { values, handleBlur, handleChange } = props;

  return (
    <>
      <Row gutter={16}>
        <Col span={12}>
          <Form.Item className="flex flex-col">
            <span className="text-sm">Document Detail</span>
            <Input
              name="document_name"
              placeholder="Document Name"
              value={values.document_name}
              onChange={handleChange}
              onBlur={handleBlur}
              className="!rounded"
              style={{ padding: "8px", width: "500px" }}
              size="large"
            />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item className="flex flex-col">
            <span className="text-sm">Document Number</span>
            <Input
              name="document_number"
              placeholder="Document Number"
              value={values.document_number}
              onChange={handleChange}
              onBlur={handleBlur}
              className="!rounded"
              style={{ padding: "8px" }}
              size="large"
            />
          </Form.Item>
        </Col>
      </Row>
    </>
  );
};

export default DocumentDetails;
